<template>
  <div class="con6">
    <div class="con6_box">
      <div class="con6_title">{{ title }}</div>
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <a target="_blank" :title="item.title">
            <img :src="item.img" alt="item.title" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
  },
}
</script>

<style lang="less" scoped>
.con6 {
  width: 100%;
  height: 490px;
  background: #f8f8f8;
}

.con6_box {
  width: 1200px;
  margin: auto;

  .con6_title {
    width: 100%;
    margin: auto;
    text-align: center;
    font-size: 36px;
    color: #070707;
    display: flex;
    justify-content: center;
    padding-top: 70px;
  }

  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 40px;
  }

  li {
    width: 160px;
    height: 66px;
    margin-left: 16px;
    margin-top: 16px;

    a {
      display: flex;
    }
  }
}
</style>
